module.exports = __webpack_public_path__ + "img/marker-pin-02.062b8dea.svg";